// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"a9af63a2","453":"46dc3e92"}[chunkId] + ".chunk.js";
};